import React, { createContext, useContext, useState, ReactNode } from 'react';

type ContactContextType = {
  isContactOpen: boolean;
  initialMessage: string;
  openContact: (message?: string) => void;
  closeContact: () => void;
};

const ContactContext = createContext<ContactContextType | undefined>(undefined);

export const ContactProvider = ({ children }: { children: ReactNode }) => {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [initialMessage, setInitialMessage] = useState('');

  const openContact = (message = '') => {
    setInitialMessage(message);
    setIsContactOpen(true);
  };

  const closeContact = () => {
    setIsContactOpen(false);
  };

  return (
    <ContactContext.Provider value={{ isContactOpen, initialMessage, openContact, closeContact }}>
      {children}
    </ContactContext.Provider>
  );
};

export const useContact = () => {
  const context = useContext(ContactContext);
  if (context === undefined) {
    throw new Error('useContact must be used within a ContactProvider');
  }
  return context;
};
